import React from 'react';
import { forwardRef } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import mdStyles from './markdown.less';
import { ChatMsg } from './messageMapper';

interface Props {
  messages: ChatMsg[];
}

/**
 * 分享生成图片用的极简版消息渲染：
 * - 去掉时间、token tag、复制/分享按钮、勾选圆圈、头像
 * - 思考卡片只显示折叠态摘要（即"分析完成 耗时 xs"）
 * - 固定宽度 640，白底，避免 hover / 动画影响截图
 */
const ShareImageCanvas = forwardRef<HTMLDivElement, Props>(({ messages }, ref) => {
  return (
    <div
      ref={ref}
      style={{
        width: 640,
        padding: 24,
        background: '#fff',
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif',
        color: '#1d2129',
        fontSize: 14,
        lineHeight: 1.6
      }}
    >
      {messages.map((m) => {
        if (m.role === 'user') {
          return (
            <div
              key={m.id}
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginBottom: 14
              }}
            >
              <div
                style={{
                  maxWidth: '80%',
                  padding: '10px 14px',
                  background: 'linear-gradient(135deg, #2A6FF5, #5B8DEF)',
                  color: '#fff',
                  borderRadius: '14px 14px 4px 14px',
                  fontSize: 14,
                  lineHeight: 1.6,
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word'
                }}
              >
                {m.content}
              </div>
            </div>
          );
        }
        return (
          <div key={m.id} style={{ marginBottom: 14 }}>
            {m.thinking && (m.thinking.status === 'done' || m.thinking.status === 'failed') && (
              <div
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 6,
                  padding: '4px 10px',
                  marginBottom: 8,
                  borderRadius: 8,
                  background: '#F0F5FF',
                  color: '#4B5563',
                  fontSize: 12
                }}
              >
                <span style={{ color: m.thinking.status === 'failed' ? '#FF525D' : '#52C41A' }}>
                  {m.thinking.status === 'failed' ? '✕' : '✓'}
                </span>
                <span>{m.thinking.status === 'failed' ? '分析失败' : '分析完成'}</span>
              </div>
            )}
            {m.content && (
              <div
                style={{
                  padding: '10px 14px',
                  background: '#fff',
                  color: '#262626',
                  borderRadius: '14px 14px 14px 4px',
                  wordBreak: 'break-word',
                  border: '1px solid #F0F0F0'
                }}
              >
                <div className={mdStyles.aiBubbleContent}>
                  <ReactMarkdown remarkPlugins={[remarkGfm]}>{m.content}</ReactMarkdown>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
});

ShareImageCanvas.displayName = 'ShareImageCanvas';

export default ShareImageCanvas;
